import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import noop from 'lodash/noop';
import Flag, { FlagGroup } from '@atlaskit/flag';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';
import allowedIcons from './utils/allowed-icons';
// eslint-disable-next-line @repo/internal/react/no-class-components
var EngagementFlag = /*#__PURE__*/function (_Component) {
  _inherits(EngagementFlag, _Component);
  var _super = _createSuper(EngagementFlag);
  function EngagementFlag() {
    var _this;
    _classCallCheck(this, EngagementFlag);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onDismiss", function () {
      _this.props.fireClickEvent('dismiss');
    });
    _defineProperty(_assertThisInitialized(_this), "onPrimaryClick", function () {
      var _this$props = _this.props,
        fireClickEvent = _this$props.fireClickEvent,
        primaryAction = _this$props.primaryAction;
      fireClickEvent('primary');
      _this.onClickActionHandler(primaryAction);
    });
    _defineProperty(_assertThisInitialized(_this), "onSecondaryClick", function () {
      var _this$props2 = _this.props,
        fireClickEvent = _this$props2.fireClickEvent,
        secondaryAction = _this$props2.secondaryAction;
      fireClickEvent('secondary');
      _this.onClickActionHandler(secondaryAction);
    });
    return _this;
  }
  _createClass(EngagementFlag, [{
    key: "onClickActionHandler",
    value: function onClickActionHandler(action) {
      if (action && action.type === buttonActionTypes.LINK && action.data) {
        window.open(action.data.url, action.data.target);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        title = _this$props3.title,
        body = _this$props3.body,
        primaryText = _this$props3.primaryText,
        secondaryText = _this$props3.secondaryText,
        icon = _this$props3.icon;
      var actions = [{
        content: primaryText,
        onClick: this.onPrimaryClick
      }];
      if (secondaryText) {
        actions.push({
          content: secondaryText,
          onClick: this.onSecondaryClick
        });
      }
      var selectedIcon = allowedIcons[icon];
      var FlagIconComponent = selectedIcon && selectedIcon.component;
      var FlagIcon = FlagIconComponent ? /*#__PURE__*/React.createElement(FlagIconComponent, {
        label: selectedIcon.label,
        color: selectedIcon.color,
        spacing: "spacious"
      }) : null;
      return /*#__PURE__*/React.createElement(FlagGroup, {
        onDismissed: this.onDismiss
      }, /*#__PURE__*/React.createElement(Flag, {
        id: "engagement-flag",
        appearance: "normal",
        icon: FlagIcon,
        title: title,
        description: /*#__PURE__*/React.createElement(HtmlContent, {
          html: body
        }),
        actions: actions
      }));
    }
  }]);
  return EngagementFlag;
}(Component);
_defineProperty(EngagementFlag, "defaultProps", {
  fireClickEvent: noop,
  primaryText: null,
  primaryAction: null,
  secondaryText: null,
  secondaryAction: null,
  icon: 'smallInfo'
});
export { EngagementFlag as default };